/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type tasksAddTaskMutationVariables = {
    readonly participant_id: string;
    readonly label: string;
};
export type tasksAddTaskMutationResponse = {
    readonly addParticipantTask: ({
        readonly task: ({
            readonly id: string;
            readonly label: string | null;
            readonly completed_at: string | null;
            readonly created_at: string;
        }) | null;
        readonly result: MutationResult;
        readonly description: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    }) | null;
};
export type tasksAddTaskMutation = {
    readonly response: tasksAddTaskMutationResponse;
    readonly variables: tasksAddTaskMutationVariables;
};



/*
mutation tasksAddTaskMutation(
  $participant_id: String!
  $label: String!
) {
  addParticipantTask(participant_id: $participant_id, label: $label) {
    task {
      id
      label
      completed_at
      created_at
    }
    result
    description
    errors
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "participant_id",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "label",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "addParticipantTask",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "label",
                    "variableName": "label"
                },
                {
                    "kind": "Variable",
                    "name": "participant_id",
                    "variableName": "participant_id"
                }
            ],
            "concreteType": "NewParticipantTask",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "task",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ParticipantTask",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "completed_at",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "created_at",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "result",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "errors",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "tasksAddTaskMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "tasksAddTaskMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "tasksAddTaskMutation",
            "id": null,
            "text": "mutation tasksAddTaskMutation(\n  $participant_id: String!\n  $label: String!\n) {\n  addParticipantTask(participant_id: $participant_id, label: $label) {\n    task {\n      id\n      label\n      completed_at\n      created_at\n    }\n    result\n    description\n    errors\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b4251d3ead3276be8f67db6a84c191f0';
export default node;
